import React from 'react';
import { OptionSizesSkeleton } from '../Skeleton/OptionSizes.Skeleton';
import { AddButtonWrapperSkeleton } from '../Skeleton/AddButtonWrapper.Skeleton';
import { OptionColorsSkeleton } from '../Skeleton/OptionColors.Skeleton';
import { MEDIA_BREAKPOINTS } from '../../../../../constants/MEDIA_BREAKPOINTS';
import { ppData } from '../../../configs/ppData.config';
import { OptionLayoutsSkeleton } from '../Skeleton/OptionLayouts.Skeleton';
const types = ['w:64', 'w:32', 'w:48', 'w:44', 'w:64'];
export const CustomCanvasFormSkeleton = () => (React.createElement("div", null,
    React.createElement("div", { className: "mt:28 d:flex fd:column" },
        React.createElement("div", { className: "d:flex mb:16" },
            React.createElement("div", { className: "skeleton fz:14 h:lh w:1/6" })),
        React.createElement("div", { className: "d:flex bd bd:bw:1 bd:c:border-light" }, types.map((cls, i) => (React.createElement("div", { className: i > 0 ? 'ml:16' : undefined, key: i },
            React.createElement("div", { className: "fz:12 fz:14:xl-up" },
                React.createElement("span", { className: `d:block skeleton h:lh ${cls}` }))))))),
    React.createElement(OptionLayoutsSkeleton, { nbItems: ppData.isCustomFramedCanvas ? 2 : 5, showLabel: false, showItemLabel: false }),
    React.createElement(OptionSizesSkeleton, null),
    ppData.isCustomFramedCanvas &&
        React.createElement(React.Fragment, null,
            React.createElement(OptionSizesSkeleton, { sizes: ['w:112', 'w:80', 'w:112', 'w:96'] }),
            React.createElement(OptionColorsSkeleton, { nbItems: 6 })),
    MEDIA_BREAKPOINTS.LG_UP.matches &&
        React.createElement(AddButtonWrapperSkeleton, null)));
